/**
 * BroadcastChannel bridge — always mounted at the app shell level.
 * Listens for messages from the pop-out chat window and relays them
 * through CompanionManager. Independent of whether the ChatDrawer is open.
 */

import { useEffect } from 'react'
import { useCompanionManager } from '@edge/edge-ai'
import type { CompanionEvent } from '@edge/edge-ai'
import { followSpanishQuestion } from '@/features/companion/language-follow'

export const CHAT_CHANNEL_NAME = 'edge-chat'

export function ChatBroadcastBridge() {
  const manager = useCompanionManager()

  useEffect(() => {
    const channel = new BroadcastChannel(CHAT_CHANNEL_NAME)

    // Handle messages from pop-out window
    channel.onmessage = (event: MessageEvent) => {
      const data = event.data
      if (data.type === 'ping') {
        channel.postMessage({ type: 'pong' })
        channel.postMessage({ type: 'messages-sync', messages: [...manager.messages] })
      }
      if (data.type === 'send-message' && data.text) {
        followSpanishQuestion(data.text, manager)
        manager.sendChatMessage(data.text)
      }
    }

    // Forward new messages to pop-out
    const unsub = manager.events.on((event: CompanionEvent) => {
      if (event.type === 'message') {
        channel.postMessage({ type: 'new-message', messages: [...manager.messages] })
      }
    })

    return () => {
      unsub()
      channel.close()
    }
  }, [manager])

  return null
}
